import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController
} from "ionic-angular";
import { Observable } from "rxjs";

import { Constants } from "../../../providers";
import { NodeAvailabilityProvider } from "../../../providers/node-availability/node-availability";

@IonicPage()
@Component({
  selector: "page-in-toggles",
  templateUrl: "in-toggles.html"
})
export class InTogglesPage {
  public currentNodes: any[] = [];
  public localNodes: any;
  public lightNodes: any[] = [];
  public blindNodes: any[] = [];
  public awningNodes: any[] = [];
  public climaNodes: any[] = [];
  public tempNodes: any[] = [];
  public temperatureNodes: any[] = [];
  public mailboxNodes: any[] = [];
  public heatersNodes: any[] = [];

  private toggle_nodes = Constants.APP_KEY + ":toggle_nodes";
  private section: string;

  constructor(
    private availability: NodeAvailabilityProvider,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.section = this.navParams.get("section"); //in|out
    this.toggle_nodes += `:${this.section}`;
  }

  ionViewDidLoad() {
    let loader = this.loadingCtrl.create({
      content: "Loading devices...",
      dismissOnPageChange: false
    });
    loader.present();

    Observable.zip(
      this.availability.getSpecificNodes("light"),
      this.availability.getSpecificNodes("blind"),
      this.availability.getSpecificNodes("awning"),
      this.availability.getSpecificNodes("clima"),
      this.availability.getSpecificNodes("temp"),
      this.availability.getSpecificNodes("temperature"),
      this.availability.getSpecificNodes("heater"),
      this.availability.getSpecificNodes("mailbox")
    ).subscribe(
      ([
        lights,
        blinds,
        awnings,
        clima,
        temp,
        temperature,
        heaters,
        mailbox
      ]) => {
        this.currentNodes = [
          ...lights,
          ...blinds,
          ...awnings,
          ...clima,
          ...temp,
          ...temperature,
          ...heaters,
          ...mailbox
        ];

        this.removeFromStorage(this.currentNodes);
        this.localNodes = this.updateStorage(this.currentNodes);

        this.lightNodes = lights;
        this.blindNodes = blinds;
        this.awningNodes = awnings;
        this.climaNodes = clima;
        this.tempNodes = temp;
        this.temperatureNodes = temperature;
        this.heatersNodes = heaters;
        this.mailboxNodes = mailbox;

        loader.dismissAll();
      },
      err => {
        loader.dismissAll();
        console.log("error");
      }
    );
  }

  removeFromStorage(nodes: any[]) {
    let stringNodes = localStorage.getItem(this.toggle_nodes);
    let storageNodes = {};
    if (stringNodes) {
      storageNodes = JSON.parse(stringNodes);
    }
    for (let key in storageNodes) {
      if (!nodes.filter(item => item._id === key).length) {
        delete storageNodes[key];
      }
    }
    localStorage.setItem(this.toggle_nodes, JSON.stringify(storageNodes));
    this.localNodes = storageNodes;
  }

  updateStorage(nodes: any[]) {
    let stringNodes = localStorage.getItem(this.toggle_nodes);
    let storageNodes = {};
    if (stringNodes) {
      storageNodes = JSON.parse(stringNodes);
    }
    for (let i = 0; i < nodes.length; i++) {
      if (!storageNodes[nodes[i]._id]) {
        storageNodes[nodes[i]._id] = {
          active: false,
          available: false,
          endpoints: []
        };

        if (nodes[i].scheme.endpoints.length) {
          for (let j = 0; j < nodes[i].scheme.endpoints.length; j++) {
            if (nodes[i].scheme.endpoints[j].dir !== "input") {
              let stateOn = null;
              let stateOff = null;
              let device = nodes[i]._id;
              let endpoint = nodes[i].scheme.endpoints[j]._id;

              switch (nodes[i].scheme.endpoints[j].type) {
                case "stateful":
                  const stateLength =
                    nodes[i].scheme.endpoints[j].states.length;
                  if (stateLength > 0) {
                    const stateOffFound = nodes[i].scheme.endpoints[
                      j
                    ].states.filter(
                      item => item.value == 0 || item.value == "false"
                    )[0];
                    const stateOnFound = nodes[i].scheme.endpoints[
                      j
                    ].states.filter(
                      item => item.value == 1 || item.value == "true"
                    )[0];
                    stateOff = stateOffFound ? stateOffFound.name : null;
                    stateOn = stateOnFound ? stateOnFound.name : null;
                    break;
                  }
                  continue;
                case "stateless":
                  const valueLength = nodes[i].scheme.endpoints[j].value.length;
                  if (valueLength > 0) {
                    stateOff = nodes[i].scheme.endpoints[j].value[0].min;
                    stateOn = nodes[i].scheme.endpoints[j].value[0].max;
                    break;
                  }
                  continue;
              }
              storageNodes[nodes[i]._id].endpoints.push({
                stateOn: stateOn,
                stateOff: stateOff,
                defaultState: false,
                data: {
                  device: device,
                  endpoint: endpoint,
                  value: stateOff
                }
              });
            }
          }
        }
      }
    }
    localStorage.setItem(this.toggle_nodes, JSON.stringify(storageNodes));

    return storageNodes;
  }

  changeState(deviceId, endpointId, active, onlyOne = false) {
    let stringNodes = localStorage.getItem(this.toggle_nodes);
    let storageNodes = {};
    if (stringNodes) {
      storageNodes = JSON.parse(stringNodes);
    }

    if (storageNodes[deviceId]) {
      for (let i = 0; i < storageNodes[deviceId].endpoints.length; i++) {
        if (storageNodes[deviceId].endpoints[i].data.endpoint === endpointId) {
          storageNodes[deviceId].endpoints[i].defaultState = active;
          if (active) {
            storageNodes[deviceId].endpoints[i].data.value =
              storageNodes[deviceId].endpoints[i].stateOn;
          } else {
            storageNodes[deviceId].endpoints[i].data.value =
              storageNodes[deviceId].endpoints[i].stateOff;
          }
        } else if (onlyOne && active) {
          storageNodes[deviceId].endpoints[i].defaultState = false;
          storageNodes[deviceId].endpoints[i].data.value =
            storageNodes[deviceId].endpoints[i].stateOff;
        }
      }
      localStorage.setItem(this.toggle_nodes, JSON.stringify(storageNodes));
      this.localNodes = storageNodes;
    }
  }

  changeAvailability(deviceId, available) {
    let stringNodes = localStorage.getItem(this.toggle_nodes);
    let storageNodes = {};
    if (stringNodes) {
      storageNodes = JSON.parse(stringNodes);
    }
    if (storageNodes[deviceId]) {
      storageNodes[deviceId].available = available;
      for (let i = 0; i < storageNodes[deviceId].endpoints.length; i++) {
        storageNodes[deviceId].endpoints[i].defaultState = false;
        storageNodes[deviceId].endpoints[i].data.value =
          storageNodes[deviceId].endpoints[i].stateOff;
      }
      localStorage.setItem(this.toggle_nodes, JSON.stringify(storageNodes));
      this.localNodes = storageNodes;
    }
  }

  updateNodeLocal(id, ev) {
    let tempObject = JSON.parse(localStorage.getItem(this.toggle_nodes));
    tempObject[id].stateArrive = ev.checked;
    localStorage.setItem(this.toggle_nodes, JSON.stringify(tempObject));
  }

  ionViewDidUnload() {}
}



// WEBPACK FOOTER //
// ./src/pages/global-settings/in-toggles/in-toggles.ts